import { FC } from 'react';

export const withDefaultProps: <TProps>(
  Component: FC<TProps>,
  defaultProps: Partial<TProps>
) => FC<TProps> = (Component, defaultProps) => (props) =>
  <Component {...defaultProps} {...props} />;
